/* Publish by EComposer at 2026-10-31 06:00:07*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-lcjic3l221h"]=  window.__ectimmers["ecom-lcjic3l221h"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-lcjic3l221h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lcjic3l221h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2allls81nf9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2allls81nf9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3vlnlotx72h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3vlnlotx72h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hpjb6qk2ddk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hpjb6qk2ddk', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-8b5bnhvdjxh"]=  window.__ectimmers["ecom-8b5bnhvdjxh"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-8b5bnhvdjxh"]["e90vcq0nj"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let n=this.$el;if(!n)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function s(){let r=n.querySelector(".ecom-element.ecom-base-image"),a=n.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){s()})

                    });
                    
                        document.querySelectorAll('.ecom-8b5bnhvdjxh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8b5bnhvdjxh', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}